import React from 'react';
import {Link} from 'react-router';


export default class Footer extends React.Component {
  backToTop(e) {
    e.preventDefault();

    let cosParameter = window.scrollY / 2,
      scrollCount = 0,
      oldTimestamp = performance.now();

    function step(newTimestamp) {
      scrollCount += Math.PI / (1000 / (newTimestamp - oldTimestamp));
      if (scrollCount >= Math.PI) window.scrollTo(0, 0);
      if (window.scrollY === 0) return;
      window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
      oldTimestamp = newTimestamp;
      window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  render() {
    return (
      <footer className="ba-site-footer">
        <a className="back-to-top"
           onClick={this.backToTop}>
          <span className="fa fa-caret-up"
                title="Back to Top"
                aria-hidden="true" />
          Back to Top
        </a>
        <div className="row">

          <div className="large-3 columns">
            <li><Link className="terms-button" to="terms">Terms of Use</Link></li>
          </div>

        </div>

      </footer>
    );
  }
}

Footer.displayName = 'Footer';



// WEBPACK FOOTER //
// ./shared/common/Footer.jsx